
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/greenplum",
      function () {
        return require("private-next-pages/sources/greenplum.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/greenplum"])
      });
    }
  